/*
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSquare } from '@fortawesome/pro-light-svg-icons'
import { faCheckSquare } from '@fortawesome/pro-solid-svg-icons'
*/

export default {
  install(Vue) {
    /*
    Vue.component('font-awesome-icon', FontAwesomeIcon);

    library.add(faSquare);
    library.add(faCheckSquare);

    dom.i2svg();
    dom.watch();
    */
  }
};
